function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LocaleKeys from '../../../../../../locales/keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { CART_ITEM_TYPE } from '../../../../../../reducers/constants/products.wizard.constants';
var CART_ITEM_MORE_MENU_ITEMS = {
  REMOVE: 'remove',
  EDIT: 'edit',
  TERMS_CONDITIONS: 'terms_conditions'
};
var CartController = /*#__PURE__*/function () {
  function CartController($ngRedux, $timeout, $window) {
    _classCallCheck(this, CartController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      $window: $window,
      localeKeys: LocaleKeys,
      PRODUCT_CLASSIFICATIONS: PRODUCT_CLASSIFICATIONS
    });
  }
  return _createClass(CartController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          isDbss: IsDbss(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget)(function (state) {
        _this.state = state;
      });
      this.DEFAULT_MENU_ITEMS = [];
      this.cartItemClasses = _defineProperty(_defineProperty({}, CART_ITEM_TYPE.ADDITION, 'is-addition'), CART_ITEM_TYPE.REMOVAL, 'is-removal');
      this.handleMoreOptionsMenuSelected = function (item) {
        switch (item.item.id) {
          case CART_ITEM_MORE_MENU_ITEMS.EDIT:
            _this.onEditOptionSelect();
            break;
          case CART_ITEM_MORE_MENU_ITEMS.REMOVE:
            if (_this.onRemove()) {
              _this.onRemove()(_this.cartItem);
            }
            break;
          case CART_ITEM_MORE_MENU_ITEMS.TERMS_CONDITIONS:
            _this.onTermsAndConditionsOptionSelect();
            break;
          default:
            break;
        }
      };

      /*** Select Options Modal for editing a cartItem ***/
      this.removeCartItem = function () {
        _this.onRemove()(_this.cartItem);
      }.bind(this);
      this.onEditOptionSelect = function () {
        _this.onEdit()(_this.cartItem);
      };
      this.termsAndConditionsPopupApi = null;
      this.termsAndConditionsPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.termsAndConditionsPopupApi = api;
        }
      };
      this.closeTermsDialog = this.closeTermsDialog.bind(this);
      this.hasChildrenToShow = function () {
        return _this.cartItem.childItems && _this.cartItem.childItems.length > 0;
      };
      this.toggleShowDetails = function () {
        _this.showShowDetails = !_this.showShowDetails;
        _this.showHideDetailsLabel = _this.showShowDetails ? _this.translatedShowDetailsLabel : _this.translatedHideDetailsLabel;
      };
      this.translatedShowDetailsLabel = i18n.translate(this.localeKeys.ORDER_DETAILS.SHOW_DETAILS);
      this.translatedHideDetailsLabel = i18n.translate(this.localeKeys.ORDER_DETAILS.HIDE_DETAILS);
      this.showShowDetails = true;
      this.showHideDetailsLabel = this.translatedShowDetailsLabel;
      this.updateMenuItems();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.cartItemRemovable && this.DEFAULT_MENU_ITEMS) {
        this.updateMenuItems();
      }
    }
  }, {
    key: "getCartItemClass",
    value: function getCartItemClass() {
      return this.cartItemClasses[this.cartItem.itemType];
    }
  }, {
    key: "updateMenuItems",
    value: function updateMenuItems() {
      this.moreOptionsMenuItems = this.DEFAULT_MENU_ITEMS.concat([]);
      if (this.cartItem.isEditable) {
        this.moreOptionsMenuItems.push({
          id: CART_ITEM_MORE_MENU_ITEMS.EDIT,
          isDisabled: false,
          title: i18n.translate(LocaleKeys.EDIT)
        });
      }
      if (this.cartItem.isRemovable) {
        this.moreOptionsMenuItems.push({
          id: CART_ITEM_MORE_MENU_ITEMS.REMOVE,
          isDisabled: false,
          title: i18n.translate(this.cartItem.classification === this.PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE && this.cartItem.itemType === CART_ITEM_TYPE.REMOVAL ? this.localeKeys.ADD_TO_CART : this.localeKeys.REMOVE)
        });
      }
      if (this.cartItem.pricingPlanTermsAndConditions) {
        this.moreOptionsMenuItems.push({
          id: CART_ITEM_MORE_MENU_ITEMS.TERMS_CONDITIONS,
          isDisabled: false,
          title: i18n.translate(this.localeKeys.TERMS_AND_CONDITIONS)
        });
      }
    }
  }, {
    key: "onTermsAndConditionsOptionSelect",
    value: function onTermsAndConditionsOptionSelect() {
      var _this2 = this;
      if (this.cartItem.pricingPlanTermsAndConditionsIsUrl) {
        this.$window.open(this.cartItem.pricingPlanTermsAndConditions, '_blank');
      } else {
        this.showTermsAndConditionsModalPopup = true;
        this.$timeout(function () {
          _this2.termsAndConditionsPopupApi.open();
        });
      }
    }
  }, {
    key: "closeTermsDialog",
    value: function closeTermsDialog() {
      this.showTermsAndConditionsModalPopup = false;
      this.termsAndConditionsPopupApi.close();
    }
  }]);
}();
export default {
  bindings: {
    brandableCurrencyName: '<',
    cartItem: '<',
    currencyCode: '<',
    onEdit: '&',
    onEditSuccess: '&',
    onRemove: '&'
  },
  controller: CartController,
  template: require('./create.products.order.cart.item.html')
};